import { fetchGET, fetchPOST } from "../utils/handler_http";

/**
 * Obtener lista paginada de cancelaciones
 */
export const getListCancellations = async (
  { offset = 0, filterCanceledBy = "", filterSearch = "" } = {},
  jwt = "",
) => {
  const params = { offset };
  if (filterCanceledBy) params.filterCanceledBy = filterCanceledBy;
  if (filterSearch) params.filterSearch = filterSearch;
  return fetchGET(process.env.REACT_APP_CANCELLATIONS_ENDPOINT, params, {
    Authorization: jwt,
  });
};

/**
 * Obtener detalle completo de una cancelación por serviceId
 */
export const getCancellationDetail = async (serviceId = 0, jwt = "") => {
  return fetchGET(
    process.env.REACT_APP_CANCELLATION_DETAIL_ENDPOINT,
    { serviceId },
    { Authorization: jwt },
  );
};

/**
 * Bloquear conductor temporalmente
 */
export const blockDriver = async (
  { serviceId = 0, driverId = 0, blockDuration = "", blockReason = "" } = {},
  jwt = "",
) => {
  return fetchPOST(
    process.env.REACT_APP_MANAGE_CANCELLATION_ENDPOINT,
    { action: "BLOCK_DRIVER", serviceId, driverId, blockDuration, blockReason },
    { Authorization: jwt },
  );
};

/**
 * Compensar pasajero con cupón directo a cartera
 */
export const compensatePassenger = async (
  { serviceId = 0, passengerId = 0, couponAmount = 0, couponExpDate = "" } = {},
  jwt = "",
) => {
  return fetchPOST(
    process.env.REACT_APP_MANAGE_CANCELLATION_ENDPOINT,
    {
      action: "COMPENSATE_PASSENGER",
      serviceId,
      passengerId,
      couponAmount,
      couponExpDate,
    },
    { Authorization: jwt },
  );
};

/**
 * Marcar caso de cancelación como completado
 */
export const markCompleted = async ({ serviceId = 0 } = {}, jwt = "") => {
  return fetchPOST(
    process.env.REACT_APP_MANAGE_CANCELLATION_ENDPOINT,
    { action: "MARK_COMPLETED", serviceId },
    { Authorization: jwt },
  );
};
